const OVERLAY_SIZE_UNITS = {
  PIXEL: 'PIXEL',
  PERCENT: 'PERCENT',
};

export default OVERLAY_SIZE_UNITS;
